const Tick01Icon = /*#__PURE__*/ [
  ["path", { d: "M5 14.5C5 14.5 6.5 14.5 8.5 18C8.5 18 14.0588 8.83333 19 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { Tick01Icon as default };
//# sourceMappingURL=Tick01Icon.js.map
